import axios from 'axios/index'

const namespaced = true

const state = {
  visible: false,
  salesStatistic: null,
  salesStatisticClients: null,
  totalPackages: null,
  totalCost: null,
  totalCTMCost: null,
  totalActiveClients: null,
  totalUpdealerCost: null
}
const actions = {
  loadReportFixedPackages ({ commit }) {
    commit('setVisible', true)
    return axios({
      method: 'GET',
      responseType: 'blob',
      url: '/api/private/v3.0/billing/package-report/'
    })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Тариф минимальный.xls')
        document.body.appendChild(link)
        link.click()
        commit('setVisible', false)
      })
      .catch(error => {
        alert(error.status + ' ' + error.statusText)
        commit('setVisible', false)
      })
  },
  getActiveClientsWithoutCtmIdReport ({ commit }, data) {
    commit('setVisible', true)
    return axios({
      method: 'GET',
      responseType: 'blob',
      url: `/api/private/v3.0/groups/activity?year=${data.year}&month=${data.month}`
    })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Активные_клиенты_без_CTM_ID_${data.year}_${data.month}.xls`)
        document.body.appendChild(link)
        link.click()
        commit('setVisible', false)
      })
      .catch(error => {
        alert(error.status + ' ' + error.statusText)
        commit('setVisible', false)
      })
  },
  loadSalesStatistic ({ commit, rootState }, date) {
    return axios({
      method: 'GET',
      url: `/api/private/v3.0/billing/months/${date}/dealers/${rootState.authorization.userInfo.company.company_profile.ctm_id}/reports/clients-price-positions-detail/`
    })
      .then(response => {
        console.log(response)
        commit('setSalesStatistic', response.data)
      })
      .catch(error => {
        console.log(error.response)
      })
  },
  loadDealerReportXlsx ({ commit, rootState }, data) {
    return axios({
      method: 'GET',
      responseType: 'blob',
      url: `/api/private/v3.0/billing/months/${data.date}/dealers/${rootState.authorization.userInfo.company.company_profile.ctm_id}/reports/clients-price-positions-detail/xlsx/?id=${data.dealerId}`
    })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Статистика_продаж_${data.dealerName}_${data.dateString}.xls`)
        document.body.appendChild(link)
        link.click()
        commit('setVisible', false)
      })
      .catch(error => {
        alert(error.status + ' ' + error.statusText)
        commit('setVisible', false)
      })
  },
  loadDealerReportProminvestXlsx ({ commit, rootState }, data) {
    const arrOfDate = data.dateString.split('/')
    const formattedDate = arrOfDate[1] + '_' + arrOfDate[0]
    return axios({
      method: 'GET',
      responseType: 'blob',
      url: `/api/private/v3.0/billing/months/${data.date}/dealers/${rootState.authorization.userInfo.company.company_profile.ctm_id}/reports/clients-price-positions-detail/prominvest-xlsx/?id=${data.dealerId}`
    })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Отчет_КП_${formattedDate}_${data.dealerName}.xls`)
        document.body.appendChild(link)
        link.click()
        commit('setVisible', false)
      })
      .catch(error => {
        alert(error.status + ' ' + error.statusText)
        commit('setVisible', false)
      })
  },
  loadDealerReportXml ({ commit, rootState }, date) {
    return axios({
      method: 'GET',
      responseType: 'blob',
      url: `/api/private/v3.0/billing/months/${date}/dealers/${rootState.authorization.userInfo.company.company_profile.ctm_id}/reports/pik-jug-1c/`
    })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Отчет для выгрузки в 1С.xml')
        document.body.appendChild(link)
        link.click()
        commit('setVisible', false)
      })
      .catch(error => {
        alert(error.status + ' ' + error.statusText)
        commit('setVisible', false)
      })
  }
}
const mutations = {
  setVisible (state, value) {
    state.visible = value
  },
  setSalesStatistic (state, data) {
    state.salesStatistic = data
    state.salesStatistic.forEach((elm) => {
      state.totalPackages += elm.total_packages
      state.totalCost += elm.total_cost
      state.totalCTMCost += elm.ctm_cost
      state.totalUpdealerCost += elm.updealer_cost
    })
    const clients = data.map((elm) => {
      return elm.clients
    })
    state.salesStatisticClients = [].concat(...clients)
    state.totalActiveClients = state.salesStatisticClients.length
  },
  clearStatistic (state) {
    state.totalPackages = null
    state.totalCost = null
    state.totalCTMCost = null
    state.salesStatistic = null
    state.salesStatisticClients = null
    state.totalActiveClients = null
    state.totalUpdealerCost = null
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations
}
